import { createFeatureSelector, createSelector } from '@ngrx/store';
import { IInternalOrderState } from '../reducers/internal-order.reducer';

export const selectInternalOrderState =
  createFeatureSelector<IInternalOrderState>('internalOrder');

export const selectInternalOrderCodesData = createSelector(
  selectInternalOrderState,
  (state: IInternalOrderState) => state.codesData
);

// sorted list of codes for the billing-code dropdown
export const selectInternalOrderCodes = createSelector(
  selectInternalOrderCodesData,
  (codesData) => Object.values(codesData || {}).sort()
);

export const selectInternalOrderCodesFetched = createSelector(
  selectInternalOrderState,
  (state: IInternalOrderState) => state.fetched
);

export const selectInternalOrderCodesFetching = createSelector(
  selectInternalOrderState,
  (state: IInternalOrderState) => state.fetching
);
